import React from "react";
import { Box, Typography, MenuItem, Collapse } from "@mui/material";
import { ClipboardIcon, QuotesIcon } from "design-system/icons";
import { grayDark, grayLight, black } from "design-system/colors";
import { GlobalSearchTripInfo, RequestStage } from "types";

// Style constants
const SECTION_PADDING_LEFT = 5;
const SECTION_PADDING_RIGHT = 2;
const SECTION_PADDING_BOTTOM = 1;
const HEADER_FONT_SIZE = "0.7rem";
const HEADER_FONT_WEIGHT = 600;
const HEADER_LETTER_SPACING = 0.5;
const ITEM_BORDER_RADIUS = "4px";
const ITEM_PADDING_Y = 0.75;
const ITEM_PADDING_X = 1;
const ITEM_MARGIN_TOP = 0.5;
const TRIP_NUMBER_FONT_SIZE = "0.8rem";
const TRIP_NUMBER_MARGIN_LEFT = 8;
const DATE_FONT_SIZE = "0.75rem";
const DATE_MARGIN_LEFT = 8;

type RelatedTripsSectionProps = {
  trips: GlobalSearchTripInfo[];
  onTripClick: (trip: GlobalSearchTripInfo) => void;
  show: boolean;
};

function RelatedTripsSection({
  trips,
  onTripClick,
  show,
}: RelatedTripsSectionProps) {
  if (trips.length === 0 || !show) {
    return null;
  }

  return (
    <Collapse in={true} timeout="auto">
      <Box pl={SECTION_PADDING_LEFT} pr={SECTION_PADDING_RIGHT} pb={SECTION_PADDING_BOTTOM}>
        <Typography
          variant="caption"
          style={{
            fontSize: HEADER_FONT_SIZE,
            fontWeight: HEADER_FONT_WEIGHT,
            letterSpacing: HEADER_LETTER_SPACING,
            color: black,
          }}
        >
          RELATED TRIPS & QUOTES
        </Typography>
        {trips.map((trip) => {
          const isQuote = trip.stage === RequestStage.Quote;
          const icon = isQuote ? (
            <QuotesIcon color={grayDark} size="small" />
          ) : (
            <ClipboardIcon color={grayDark} size="small" />
          );
          const label = isQuote ? "Quote" : "Trip";
          
          return (
            <MenuItem
              key={trip.tripId}
              onClick={() => onTripClick(trip)}
              sx={{
                borderRadius: ITEM_BORDER_RADIUS,
                py: ITEM_PADDING_Y,
                px: ITEM_PADDING_X,
                mt: ITEM_MARGIN_TOP,
                minHeight: "auto",
                "&:hover": {
                  backgroundColor: grayLight,
                },
              }}
            >
              <Box display="flex" alignItems="center" width="100%">
                {icon}
                <Typography
                  variant="caption"
                  style={{
                    marginLeft: TRIP_NUMBER_MARGIN_LEFT,
                    fontSize: TRIP_NUMBER_FONT_SIZE,
                    color: black,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}
                >
                  {label} #{trip.orderNumber}-{trip.tripNumber}
                </Typography>
              {trip.dateString && (
                <Typography
                  variant="caption"
                  style={{
                    fontSize: DATE_FONT_SIZE,
                    color: grayDark,
                    marginLeft: DATE_MARGIN_LEFT,
                    whiteSpace: "nowrap",
                  }}
                >
                  {trip.dateString}
                </Typography>
              )}
              </Box>
            </MenuItem>
          );
        })}
      </Box>
    </Collapse>
  );
}

export default RelatedTripsSection;